import DropdownSelect from 'trunks/vue/admin/components/libs/dropdown_select.js';
import RichTextEditor from 'trunks/vue/admin/components/libs/richtext_editor.js';
import Popover from 'trunks/vue/admin/components/libs/popover.js';

import { FIELD_GROUPS, GROUP_MAP, VISIBILITIES } from './constants.js';

export default {
  components: {
    Dropdown: DropdownSelect,
    RichTextEditor,
    Popover,
  },

  name: 'FieldView',

  props: {
    field: {
      type: Skylark.App.Model.Field.Base,
      required: true,
    },
    editing: Boolean,
    field_groups: Array,
    visibilities: {
      type: Array,
      default() {
        return VISIBILITIES;
      },
    },
    fillSettings: {
      type: Object,
      default() {
        return {};
      },
    },
    disabledFieldLayout: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      descriptionExist: false,
      isNewField: this.field.isNew(),
      disables: [],
    };
  },

  template: `
    <div class="field-view" :class='statusClass' @click='enableEdit'>
      <div class="field-drag-area dragable">
        <i class="slp-move text-large"></i>
      </div>
      <div class="field-header">
        <div class="justify-box status-container">
          <div class="type-status" v-if='editing && isNewField'>
            <Dropdown v-if='field_groups.length'
                      :optionGroups='field_groups'
                      :initValue='currentGroup'
                      :optionGroupsFixed='true'
                      @change='optionChanged'>
              <template slot='value-template' slot-scope='{ option }'>
                <i :class='option.icon'></i>
                <span>{{ _getTypeTextOfField(option) }}</span>
              </template>
              <template slot='option-template' slot-scope='{ option }'>
                <i :class='option.icon'></i>
                <span>{{ _getTypeTextOfField(option) }}</span>
              </template>
            </Dropdown>
            <slot name='optionbar'></slot>
          </div>
          <div class="content settings-status">
            <span v-if='field.marked'>
              <i class="slp-bookmark"></i>
            </span>
            <span v-if='field.value_cache'>
              <i class="slp-cache"></i>
            </span>
            <span v-if='visibilityIcon'>
              <i :class='visibilityIcon'></i>
            </span>
            <span v-if='field.settings.enable_wechat_scan'>
              <i class="slp-scan-line"></i>
            </span>
          </div>
        </div>
        <div class="justify-box title-container" :class='{ required: required }'>
          <div class="content">
            <input type="text" :placeholder='defaultFieldTitle' v-model.trim='field.title' v-if='editing' ref='titleInput' />
            <div v-else>{{ field.title || defaultFieldTitle }}</div>
          </div>
          <div class="description-add-btn clickable vertical-middle" v-if='editing' @click.stop='toggleDescription'>
            <i class="slp-check" v-if='descriptionExist'></i>
            <i class="slp-empty" v-else></i>
            <span>&nbsp;添加描述</span>
          </div>
        </div>
        <div class="description-container" v-if='descriptionExist'>
          <div class="rich-text-container" v-if='editing'>
            <RichTextEditor placeholder='请输入描述'
                            v-if='isSectionBreakField'
                            ref='editor'
                            scrollingContainer='main>.main-content'
                            :value='field.description'
                            :menuSticky='false'
                            @valueChanged='updateDescription' />
          </div>
          <input type="text"
                 v-if='!isSectionBreakField'
                 :disabled='!editing'
                 ref='descriptionInput'
                 v-model.trim='field.description'
                 placeholder='请输入描述' />
          <div class="rich-text article" v-if='isSectionBreakField && !editing' v-html='field.description'></div>
        </div>
      </div>
      <div class="field-content">
        <slot name='content'></slot>
      </div>
      <div class="field-footer justify-between" v-if='editing'>
        <div class="left">
          <div class="layout-btn-container" v-if='field.availableLayouts.length > 1 && !disabledFieldLayout'>
            <button class="btn btn-default"
                    v-for='layout in field.availableLayouts'
                    :class='layout === field.settings.layout ? "outlined active" : "link-btn"'
                    :key='layout'
                    @click='updateLayout(layout)'>
              {{ _getLayoutText(layout) }}
            </button>
          </div>
        </div>
        <div class="field-actions vertical-middle">
          <div class="field-required-setting" v-if="enableRequired">
            <span>必填</span>
            <label class="switch">
              <input type="checkbox" :checked='required' @change='updateValidations' />
              <span></span>
            </label>
          </div>
          <div class="field-normal-actions">
            <span class='normal-action' @click='copyField'>
              <i class="slp-copy"></i>
            </span>
            <Popover position="bottom center" :caret='true' type="confirm" size="large" v-if="field.isPersisted()" ref='deleteFieldPopoverRef'>
              <span class='normal-action' slot='trigger'>
                <i class="slp-trash"></i>
              </span>
              <div class="popover-confirm-content" slot="content">
                <div class="popover-confirm-title">删除字段</div>
                <div class="popover-confirm-body">删除后,数据中此字段对应的记录将被删除</div>
                <div class="popover-confirm-footer">
                  <div class="btn btn-default btn-small" @click='closeDeleteFieldPopover'>取消</div>
                  <div class="btn btn-danger btn-small" @click='removeField'>删除</div>
                </div>
              </div>
            </Popover>
            <span class='normal-action' @click.stop='removeField' v-else>
              <i class="slp-trash"></i>
            </span>
            <Popover position='bottom right' v-if='settingsVisible'>
              <template slot='trigger'>
                <span class='normal-action'>
                  <i class="slp-ellipsis-v"></i>
                </span>
              </template>
              <div class="setting-groups list" slot='content'>
                <slot name="replaced-settings">
                  <div class="list-item clickable" @click='toggleMarked' v-if='!_forbidden("marked") < 0'>
                    <div class="tip">
                      <i class="slp-check" v-if='field.marked'></i>
                      <i class="slp-empty" v-else></i>
                    </div>
                    <div class="content force-no-wrap">标记字段</div>
                  </div>
                  <div class="list-item clickable" @click='toggleValueCache' v-if='!_forbidden("value_cache") < 0'>
                    <div class="tip">
                      <i class="slp-check" v-if='field.value_cache'></i>
                      <i class="slp-empty" v-else></i>
                    </div>
                    <div class="content force-no-wrap">缓存用户输入</div>
                  </div>
                  <div class="list-group" v-if='!_forbidden("visibility")'>
                    <div class="list-group-name">可见范围</div>
                    <div class="list-item clickable"
                        v-for='visibility in visibilities'
                        :key='visibility'
                        @click='switchVisibility(visibility)'>
                      <div class="tip">
                        <i :class='[field.visibility === visibility ? "slp-check" : "slp-empty"]'></i>
                      </div>
                      <div class="content force-no-wrap">{{ _getViisibilityText(visibility) }}</div>
                    </div>
                  </div>
                  <slot name="fill-settings" v-if='!_forbidden("fillSettings")'></slot>
                  <slot name="common-settings"></slot>
                </slot>
              </div>
            </Popover>
          </div>
        </div>
      </div>
    </div>
  `,

  created() {
    this.descriptionExist = (this.field.type === 'Field::SectionBreak') || Boolean(this.field.description);
    if (this.field.settings.layout == null) this.field.settings.layout = this.field.availableLayouts[0];
    this.disables = this.$parent.disables;
  },

  computed: {
    visibilityIcon() {
      switch (this.field.visibility) {
        case 'public_visibility':
          return '';
        case 'protected_visibility':
        case 'next_phase_visibility':
          return 'slp-eye';
        default:
          return 'slp-chapter';
      }
    },

    statusClass() {
      return {
        'field-editing': this.editing,
        'detail-field': this.field.type === 'Field::Detail',
        'editing-child': this.$parent.childOnEditing,
        'page-field': this.field.type === 'Field::Page',
      };
    },

    required() {
      return _.contains(this.field.validations, 'presence');
    },

    enableUniquenessValidation() {
      return _.contains(this.field.validations, 'uniqueness');
    },

    settingsVisible() {
      return !this.isSectionBreakField && _.some(
        ['commonSettings', 'fillSettings', 'marked', 'value_cache', 'visibility'],
        (item) => !((this.disables || []).includes(item)),
      );
    },

    currentGroup() {
      const fieldType = this.field.type;

      let groupType = _.findKey(GROUP_MAP, (value) => (
        _.any(value, (option) => option.type === fieldType)
      ));

      if (groupType == null) groupType = fieldType;

      return _.chain(FIELD_GROUPS)
        .map((obj) => obj.options)
        .flatten()
        .find((option) => option.type === groupType)
        .value();
    },

    isSectionBreakField() {
      return this.field.type === 'Field::SectionBreak';
    },

    defaultFieldTitle() {
      return this.field.getTypeDefaultTitle();
    },

    enableRequired() {
      return !this.isSectionBreakField;
    },
  },

  methods: {
    enableEdit(event) {
      if (this.$el.getAttribute('moved')) return undefined;
      if (this.field.type === 'Field::Detail' && event.target.closest('.field-view') !== this.$el) {
        const fieldView = event.target.closest('.field-view');
        if (fieldView && fieldView.getAttribute('moved')) return undefined;
        this.$parent.childOnEditing = true;
        this.$parent.editing = false;
      } else {
        if (this.editing) return true;
        this.$parent.editing = true;
        if (this.$parent.hasOwnProperty('childOnEditing')) this.$parent.childOnEditing = false;
      }
      return undefined;
    },

    switchVisibility(visibility) {
      if (visibility === this.field.visibility) return;
      this.field.visibility = visibility;
    },

    toggleValueCache() {
      this.field.value_cache = !this.field.value_cache;
    },

    toggleMarked() {
      this.field.marked = !this.field.marked;
    },

    updateDescription(value) {
      this.field.description = value;
    },

    updateValidations(event) {
      if (event.target.checked) {
        this.field.validations.push('presence');
      } else {
        this.field.validations = _.without(this.field.validations, 'presence');
      }
    },

    updateLayout(layout) {
      this.field.settings.layout = layout;
    },

    removeField() {
      this.$parent.removeField();
    },

    copyField() {
      this.$parent.copyField();
    },

    toggleDescription() {
      if (this.field.type === 'Field::SectionBreak') return;
      if (this.descriptionExist) this.field.description = '';
      this.descriptionExist = !this.descriptionExist;
      if (!this.descriptionExist) return;
      this.$nextTick(() => {
        if (this.$refs.descriptionInput) this.$refs.descriptionInput.focus();
      });
    },

    optionChanged(option) {
      this.$parent.changeType(option);
    },

    focusTitle() {
      this.$refs.titleInput.focus();
    },

    closeDeleteFieldPopover() {
      this.$refs.deleteFieldPopoverRef.close();
    },

    _forbidden(attribute) {
      return _.contains(this.disables || [], attribute);
    },

    _getViisibilityText(visibility) {
      return Skylark.Helpers.getZH_CN(`field.visibility.${visibility}`);
    },

    _getLayoutText(layout) {
      return Skylark.Helpers.getZH_CN(`field.layout.${layout}`);
    },

    _getTypeTextOfField(field) {
      return this.$parent._getTypeText(field.type === 'Field::DateTime' ? field.params.input_type : field.type);
    },
  },
};
